import { useUserState } from "../state/user";

/**
 * How many Chave Móvel Digital signatures the professional still has.
 *
 * Comes from `accountStatus.cmdKeys` on GET /api/professionals. The field is
 * optional in the response — it is omitted rather than sent as zero when the
 * professional has no account status — so `undefined` means "unknown", which is
 * not the same as "none left" and should not be rendered as a zero.
 */
export default function useCmdKeys(): number | undefined {
  const { user } = useUserState();
  const value = user?.accountStatus?.cmdKeys;
  return typeof value === "number" ? value : undefined;
}
